
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Phone, Mail } from "lucide-react";

export function ContactSection() {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold font-primary text-gray-800 mb-4">
            Precisa de Ajuda?
          </h2>
          <p className="text-lg font-secondary text-gray-600">
            Entre em contato conosco para suporte ou dúvidas
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto">
          <Card>
            <CardContent className="p-6 text-center">
              <Phone className="w-8 h-8 text-green-600 mx-auto mb-4" />
              <h3 className="font-semibold mb-2">Telefone</h3>
              <p className="text-gray-600">(11) 99887-4081</p>
              <Button 
                variant="outline" 
                className="mt-4 w-full"
                onClick={() => window.open('https://wa.me/5511998874081', '_blank')}
              >
                Ligar Agora
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6 text-center">
              <Mail className="w-8 h-8 text-green-600 mx-auto mb-4" />
              <h3 className="font-semibold mb-2">Email</h3>
              <p className="text-gray-600">brenda.ramos.nutri@gmail.com</p>
              <Button 
                variant="outline" 
                className="mt-4 w-full"
                onClick={() => window.open('mailto:brenda.ramos.nutri@gmail.com')}
              >
                Enviar Email
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
}
